<template>
  <v-layout justify-end>
    <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
      <v-icon dark left>note_add</v-icon>New Item
    </v-btn>
    <v-dialog v-model="localDialog" persistent max-width="1500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <image-uploader
                    v-bind:constImage="local.image"
                    v-bind:dialog="dialog"
                    v-bind:errorMsg="errorMsg"
                    @image="assignImage">
                  </image-uploader>
                  <v-text-field
                    label="Name"
                    v-model="local.name"
                    :rules="generalRules"
                    required>
                  </v-text-field>

                  <h3>Type of Dimension</h3>
                  <v-radio-group v-model="local.typeOfDimension" row>
                    <v-radio :label="'3D'" :value="'3D'"></v-radio>
                    <v-radio :label="'2.5D'" :value="'2.5D'"></v-radio>
                  </v-radio-group>

                  <v-text-field
                    v-model="local.polygon_count"
                    label="Polygon Count"
                    type="number">
                  </v-text-field>

                  <v-text-field
                    v-model="local.polygonLimitation"
                    label="Polygon Limitation">
                  </v-text-field>
                  <v-textarea
                    label="Description"
                    v-model="local.description">
                  </v-textarea>

                </v-flex>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>

                <v-flex>
                  <popover title="Select the type of assets to populate the environment" :always="true">
                    <h3>Select Assets</h3>
                  </popover>
                  <v-select
                    :items="asset"
                    :item-text="item => item.name"
                    :item-value="item=> item.id"
                    v-model="local.selected_assets"
                    label="Select Assets"
                    multiple
                    chips
                    persistent-hint>
                  </v-select>
                  <p ><span>The number of asset is </span> <span style="color: crimson">{{local.selected_assets.length}}</span></p>

                  <popover :always="true">
                    <h3>Select Materials</h3>
                  </popover>
                  <v-select
                    :items="materialsSelect"
                    :item-text="item => item.name"
                    :item-value="item=> item.id"
                    v-model="local.materials"
                    label="Select Materials"
                    chips
                    persistent-hint>
                  </v-select>
                  <popover :always="true">
                    <h3>Interactive Surfaces</h3>
                  </popover>
                  <v-select
                    :items="interactiveSurfacesSelect"
                    :item-text="item => item.name"
                    :item-value="item=> item.id"
                    v-model="local.interactive_surfaces"
                    label="Interactive Surfaces"
                    chips
                    persistent-hint>
                  </v-select>
                  <popover title="Background sound for the environment" :always="true">
                    <v-checkbox
                      v-model="allow_sound"
                      label="Allow Sound">
                    </v-checkbox>
                  </popover>
                  <v-select
                    v-if="allow_sound"
                    :items="sounds"
                    :item-text="item => item.name"
                    :item-value="item=> item.id"
                    v-model="local.selected_sounds"
                    label="Select Sounds"
                    multiple
                    chips
                    persistent-hint>
                  </v-select>
                  <popover title="Particle effects attached to the environment" :always="true">
                    <v-checkbox
                      v-model="local.allow_effect"
                      label="Allow Particle Effects">
                    </v-checkbox>
                  </popover>
                  <popover title="Dimension of asset in meters(m)" :always="true">
                    <h3>Asset Dimension(x,y,z)</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.dimension.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.dimension.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.dimension.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <popover :always="true">
                    <h3>Position of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <popover :always="true">
                    <h3>Rotation of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <popover :always="true">
                    <h3>Scale of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-spacer/>
                <v-flex>
                  <!--                  test-->
                  <h3>Attachments</h3>
                  <file-uploader
                    @input="assignFBX"
                    v-model="local.fbx">
                    <div slot="activator">
                      <v-text-field
                        label="Filmbox"
                        v-model="local.fbx.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required>
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignIOS"
                    v-model="local.asset_bundle.iOS">
                    <div slot="activator">
                      <v-text-field
                        label="iOS Asset Bundle"
                        v-model="local.asset_bundle.iOS.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required
                      >
                      </v-text-field>
                    </div>
                  </file-uploader>
                  <file-uploader
                    @input="assignAndroid"
                    v-model="local.asset_bundle.Android">
                    <div slot="activator">
                      <v-text-field
                        label="Android Asset Bundle"
                        v-model="local.asset_bundle.Android.fileName"
                        readonly prepend-icon="attach_file"
                        :rules="generalRules"
                        required
                      >
                      </v-text-field>
                    </div>
                  </file-uploader>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn color="primary" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {db} from '../../../firebaseDB'
import ImageUploader from '../uploader/imageUploader'
import FileUploader from '../uploader/fileUploader'
export default {
  name: 'addSetDesign',
  components: {ImageUploader, FileUploader},
  data: () => ({
    valid: true,
    errorMsg: '',
    generalRules: [
      v => !!v || 'This field is required'
    ],
    asset: [],
    allow_sound: false,
    sounds: [],
    saving: false,
    materialsSelect: [],
    interactiveSurfacesSelect: [],
    local: {
      id: null,
      typeOfDimension: '3D',
      name: '',
      numOfAssets: 0,
      selected_sounds: [],
      selected_assets: [],
      materials: '',
      interactive_surfaces: '',
      allow_effect: false,
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      polygon_count: 1,
      polygonLimitation: '',
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      description: ''
      // service: '',
      // image: null,
      // default_lighting: [],
      // default_props: []
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    info: {
      id: '',
      name: '',
      description: '',
      image: null,
      allowed_lighting: [],
      allowed_props: [],
      default_lighting: [],
      default_props: []
    }
  },
  created () {
    // db.ref('assets/asset_data/set_lighting/')
    //     .once('value')
    //     .then(snapshot => {
    //       Object.keys(snapshot.val())
    //         .forEach(k => this.lighting.push({
    //           id: k,
    //           name: snapshot.val()[k].name
    //         }))
    //     })
    //     .catch(error => {
    //       console.log('Error - ' + error.message)
    //     })
    db.ref('assets/asset_data/prop/')
      .once('value')
      .then(snapshot => {
        Object.keys(snapshot.val())
          .forEach(k => this.asset.push({
            id: k,
            name: snapshot.val()[k].name
          }))
      })
      .catch(error => {
        console.log('Error - ' + error.message)
      })

    db.ref('assets/asset_data/sound')
      .once('value')
      .then(snapshot => {
        Object.keys(snapshot.val())
          .forEach(k => this.sounds.push({
            id: k,
            name: snapshot.val()[k].name || k
          }))
      })
      .catch(error => {
        console.log('Error - ' + error.message)
      })
  },
  computed: {
    formTitle () {
      return this.editedID === -1 ? 'New 3D/2.5D Environment' : 'Edit 3D/2.5D Environment'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
    // checkName () {
    //   // this.stories = this.stories.filter(story => story.owner === this.user)
    //   if (this.local.name.length < 1 && this.local.name !== '') {
    //     return 'Story title has to be at least 1 characters'
    //   } else if (this.stories.length > 0 && this.stories.find(story => story.title === this.newStory.title)) {
    //     return 'The story title already exists'
    //   } else {
    //     return true
    //   }
    // }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
      }
    }
  },
  methods: {
    assignImage (val) {
      this.local.image = val
    },
    assignFBX (payload) {
      this.local.fbx = payload
    },
    assignIOS (payload) {
      this.local.asset_bundle.iOS = payload
    },
    assignAndroid (payload) {
      this.local.asset_bundle.Android = payload
    },
    open () {
      this.$emit('open')
    },
    close () {
      this.$emit('close')
    },
    validateForm () {
      let flag = this.$refs.form.validate()
      if (this.local.image === null) {
        flag = false
        this.errorMsg = 'Please add a picture'
      }
      return flag
    },
    save () {
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addEnvironment3D.vue